import React from 'react';
import classNames from 'classnames';

const ActionListDivider = ({ adaptiveView = true, ...otherProps }) => {
  const classes = classNames('ws-ui-action-list-divider', {
    'ws-ui-action-list-divider--adaptive-view': adaptiveView,
  });

  return <div className={classes} {...otherProps} />;
};

export default ActionListDivider;
